import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import SponsorStrip from "./components/SponsorStrip";
import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { SiteImagesProvider } from "./context/SiteImagesContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Squadra from "./pages/Squadra";
import Palestra from "./pages/Palestra";
import News from "./pages/News";
import ChiSiamo from "./pages/ChiSiamo";
import Contatti from "./pages/Contatti";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Newsletter from "./pages/Newsletter";
import NewsletterDisiscrivi from "./pages/NewsletterDisiscrivi";
import Calendario from "./pages/Calendario";
import RitiriEstivi from "./pages/RitiriEstivi";
import NewsDetail from "./pages/NewsDetail";
import GestionaleApp from "./gestionale/GestionaleApp";
import ResetPassword from "./gestionale/pages/ResetPassword";
import ConfermaInvito from "./gestionale/pages/ConfermaInvito";
import Privacy from "./pages/Privacy";

function AppRouter() {
  return (
    <>
      <Routes>
        {/* Il gestionale gestisce il proprio layout (niente Navbar/Footer del sito) */}
        <Route path="/app/*" element={<GestionaleApp />} />

        {/* Pagina tecnica per reset password / accettazione invito (no Navbar/Footer) */}
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/conferma-invito" element={<ConfermaInvito />} />
        
        {/* Sito pubblico (Navbar + Footer invariati) */}
        <Route
          path="*"
          element={
            <>
              <Navbar />
              <SponsorStrip />
              <img src="https://okatgbxionqjmzhnazqx.supabase.co/storage/v1/object/public/Immagini%20Sito/3f805aff4915480780d328e1c05cbaab.png" alt="" className="fixed top-20 right-4 h-14 w-14 object-contain opacity-60 z-10 pointer-events-none" />
              <main className="min-h-[calc(100vh-4rem)]">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/squadra" element={<Squadra />} />
                  <Route path="/palestra" element={<Palestra />} />
                  <Route path="/calendario" element={<Calendario />} />
                  <Route path="/ritiri-estivi" element={<RitiriEstivi />} />
                  <Route path="/news" element={<News />} />
                  <Route path="/chi-siamo" element={<ChiSiamo />} />
                  <Route path="/contatti" element={<Contatti />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/newsletter" element={<Newsletter />} />
                  <Route path="/newsletter/disiscrivi" element={<NewsletterDisiscrivi />} />
                  <Route path="/news/:id" element={<NewsDetail />} />
                  <Route path="*" element={<Home />} />
                  <Route path="/privacy" element={<Privacy />} />
                </Routes>
              </main>
              <Footer />
            </>
          }
        />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <AuthProvider>
        <SiteImagesProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AppRouter />
            <Toaster theme="dark" position="top-right" richColors />
          </BrowserRouter>
        </SiteImagesProvider>
      </AuthProvider>
    </div>
    </HelmetProvider>
  );
}